import { redirect } from "react-router-dom";
import { deleteContact } from "./contacts.helper";

export async function action({ params }) {
  await deleteContact(params.contactId);
  return redirect("/contacts");
}
